import { cva } from 'class-variance-authority';
export var buttonCardStyles = /*#__PURE__*/cva(['tw-relative tw-flex tw-flex-col tw-h-28 tw-w-full tw-min-w-21.2',
// Rounding and overflow
'tw-rounded-2 tw-overflow-hidden',
// Background color
'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-04',
// Transition
'tw-transition-transform tw-will-change-transform',
// Hover
'tw-border tw-border-solid tw-border-transparent hover:tw-border-primary-light-400 tw-cursor-pointer']);